import React, { useMemo } from 'react';
import PainelRetratil from "./RatratilPainel";
import NucleoInfoCards from "./NucleoInfoCards";

const NoDataMessage = ({ message = "Nenhum dado a exibir para a seleção atual." }) => (
  <div style={{ padding: '15px', color: '#888', fontStyle: 'italic', fontSize: '14px', background: '#fff', borderRadius: '0px 0px 8px 8px' }}>
    {message}
  </div>
);

const thStyle = {
  padding: '6px 8px',
  textAlign: 'left',
  borderBottom: '2px solid #e0e0e0',
  fontWeight: 600,
  fontSize: 11,
  color: '#555',
  whiteSpace: 'nowrap',
};
const tdStyle = { padding: '5px 8px', borderBottom: '1px solid #f0f0f0', fontSize: 11 };

const StatsTable = ({ rows, columns }) => (
  <div style={{ background: '#fff', borderRadius: '0px 0px 8px 8px', boxShadow: '0 2px 6px rgba(0,0,0,0.1)', overflowX: 'auto' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ background: '#f5f5f5' }}>
          {columns.map(col => (
            <th key={col.key} style={{ ...thStyle, textAlign: col.align || 'left' }}>{col.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={columns.length} style={{ ...tdStyle, color: '#aaa', fontStyle: 'italic', textAlign: 'center', padding: 12 }}>
              Sem dados
            </td>
          </tr>
        ) : rows.map((row, i) => (
          <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
            {columns.map(col => (
              <td key={col.key} style={{ ...tdStyle, textAlign: col.align || 'left' }}>
                {col.render ? col.render(row[col.key], row) : row[col.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const PainelPrincipal = ({ nucleosFiltrados = [], loading }) => {

  const stats = useMemo(() => {
    const byTerritorio = {};
    const byMunicipio = {};
    const municipiosUnicos = new Set();

    nucleosFiltrados.forEach(f => {
      const p = f.properties || {};
      const territorio = p.TERRITORIO || 'Sem Território';
      const municipio  = p.MUNICIPIO  || '—';

      municipiosUnicos.add(municipio);

      byTerritorio[territorio] = (byTerritorio[territorio] || 0) + 1;

      if (!byMunicipio[municipio]) byMunicipio[municipio] = { territorio, count: 0 };
      byMunicipio[municipio].count++;
    });

    return {
      totalNucleos:    nucleosFiltrados.length,
      totalMunicipios: municipiosUnicos.size,
      byTerritorio,
      byMunicipio,
    };
  }, [nucleosFiltrados]);

  if (loading) {
    return <p style={{ padding: '20px', textAlign: 'center' }}>Carregando dados...</p>;
  }

  const territorioRows = Object.entries(stats.byTerritorio)
    .sort((a, b) => b[1] - a[1])
    .map(([nome, count]) => ({ nome, count }));

  const municipioRows = Object.entries(stats.byMunicipio)
    .sort((a, b) => b[1].count - a[1].count)
    .map(([nome, d]) => ({ nome, territorio: d.territorio, count: d.count }));

  const territorioColumns = [
    { key: 'nome',  label: 'Território' },
    { key: 'count', label: 'Núcleos', align: 'center' },
  ];

  const municipioColumns = [
    { key: 'nome',       label: 'Município' },
    { key: 'territorio', label: 'Território' },
    { key: 'count',      label: 'Núcleos', align: 'center' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

      <PainelRetratil titulo="Resumo Geral">
        {stats.totalNucleos > 0 ? (
          <div style={{ borderRadius: '0px 0px 8px 8px' }}>
            <NucleoInfoCards
              contagens={{
                "Núcleos": stats.totalNucleos,
                "Municípios": stats.totalMunicipios,
              }}
            />
          </div>
        ) : (
          <NoDataMessage />
        )}
      </PainelRetratil>

      <PainelRetratil titulo="Núcleos por Território">
        {territorioRows.length > 0 ? (
          <StatsTable rows={territorioRows} columns={territorioColumns} />
        ) : (
          <NoDataMessage />
        )}
      </PainelRetratil>

      <PainelRetratil titulo="Núcleos por Município">
        {municipioRows.length > 0 ? (
          <StatsTable rows={municipioRows} columns={municipioColumns} />
        ) : (
          <NoDataMessage />
        )}
      </PainelRetratil>

    </div>
  );
};

export default PainelPrincipal;
